import React from 'react'
import './spinner.scss'
import { ReactComponent as SpinnerSvg } from './spinner.svg'

const Spinner = () => {
	return <SpinnerSvg className='Spinner' />
}
export default Spinner
